import type { PanelMenuItem } from './types';
import { FullscreenEnterIcon, FullscreenExitIcon } from '@/components/icons/FullscreenIcons';
import { LockIcon } from '@/components/icons/LockIcon';

type BuildPanelMenuItemsOptions = {
    baseItems?: PanelMenuItem[];
    enableFullscreen?: boolean;
    isFullScreen?: boolean;
    onEnterFullScreen?: () => void;
    onExitFullScreen?: () => void;
    enterLabel: string;
    exitLabel: string;
    fullscreenKey?: string;
    isFullscreenLocked?: boolean;
    fullscreenTooltip?: string;
    onFullscreenLockedClick?: () => void;
};

/**
 * パネルメニュー用の共通ユーティリティ
 */
export function buildPanelMenuItems({
    baseItems,
    enableFullscreen,
    isFullScreen,
    onEnterFullScreen,
    onExitFullScreen,
    enterLabel,
    exitLabel,
    fullscreenKey = 'fullscreen',
    isFullscreenLocked,
    fullscreenTooltip,
    onFullscreenLockedClick,
}: BuildPanelMenuItemsOptions): PanelMenuItem[] {
    const items: PanelMenuItem[] = baseItems ? [...baseItems] : [];

    // 全画面表示アイコンを追加判定
    if (enableFullscreen) {
        const locked = isFullscreenLocked === true;

        // ロックされている場合は、プラン案内用のメニュー項目として追加
        // 通常の全画面アイコン + ロックインジケータ（ロック時のみ）
        if (locked) {
            items.push({
                key: fullscreenKey,
                label: enterLabel,
                icon: <FullscreenEnterIcon className="h-4 w-4" />,
                trailingIcon: <LockIcon className="h-4 w-4" />,
                onClick: onFullscreenLockedClick,
                tooltip: fullscreenTooltip,
            });
        } else if (onEnterFullScreen || onExitFullScreen) {
            items.push({
                key: fullscreenKey,
                label: isFullScreen ? exitLabel : enterLabel,
                icon: isFullScreen ? (
                    <FullscreenExitIcon className="h-4 w-4" />
                ) : (
                    <FullscreenEnterIcon className="h-4 w-4" />
                ),
                onClick: isFullScreen ? onExitFullScreen : onEnterFullScreen,
            });
        }
    }

    return items;
}
